import gql from "graphql-tag";

export const susCardLoadsList = gql`
  query susCardLoadsList(
    $from: String
    $to: String
    $offset: Int
    $limit: Int
  ) {
    fraud {
      devices_with_suspicious_card_loads(
        from: $from
        to: $to
        offset: $offset
        limit: $limit
      ) {
        average_tx
        lifetime_spend
        lifetime_spend_users
        token
        total_spend
        users {
          email
          external_reference
          dashboard_url
          snapmin_url
        }
        devices {
          external_reference
          device_only_fraud_status
        }
        top_merchants {
          id
          name
          merchant {
            merchant_limit_configuration {
              name
            }
          }
        }
        bank_card_loads {
          country_code
          external_reference
          snapmin_url
        }
      }
    }
  }
`;
